import { render, staticRenderFns } from "./LogisticsDetailsModal.vue?vue&type=template&id=4025408f&scoped=true"
import script from "./LogisticsDetailsModal.vue?vue&type=script&lang=js"
export * from "./LogisticsDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./LogisticsDetailsModal.vue?vue&type=style&index=0&id=4025408f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4025408f",
  null
  
)

export default component.exports